import { render, staticRenderFns } from "./StorageOptionsList.vue?vue&type=template&id=12a0fc99"
import script from "./StorageOptionsList.vue?vue&type=script&lang=ts"
export * from "./StorageOptionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports